/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate passwords, signatures, random data and more.`)
};

const es_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera contraseñas, firmas, datos aleatorios y más.`)
};

const de_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwörter, Signaturen, Zufallsdaten und mehr generieren.`)
};

const nl_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer wachtwoorden, handtekeningen, willekeurige gegevens en meer.`)
};

const fr_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez des mots de passe, des signatures, des données aléatoires et plus encore.`)
};

const it_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera password, firme, dati casuali e altro ancora.`)
};

const pt_br2_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere senhas, assinaturas, dados aleatórios e muito mais.`)
};

const pt_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere palavras-passe, assinaturas, dados aleatórios e muito mais.`)
};

const ja_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード、署名、ランダムデータなどを生成。`)
};

const zh_cat_generators_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成密码、签名、随机数据等。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_generators_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_generators_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_generators_desc", locale)
	if (locale === "en") return en_cat_generators_desc(inputs)
	if (locale === "es") return es_cat_generators_desc(inputs)
	if (locale === "de") return de_cat_generators_desc(inputs)
	if (locale === "nl") return nl_cat_generators_desc(inputs)
	if (locale === "fr") return fr_cat_generators_desc(inputs)
	if (locale === "it") return it_cat_generators_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_generators_desc(inputs)
	if (locale === "pt") return pt_cat_generators_desc(inputs)
	if (locale === "ja") return ja_cat_generators_desc(inputs)
	return zh_cat_generators_desc(inputs)
};